export default __webpack_public_path__ + "static/media/b3.6fb519c7.png";